import React, { type HTMLAttributes } from 'react';
import styled from 'styled-components';
import { animated, useSpring } from '@react-spring/web';

const AnimatedContainer: any = styled(animated.div)`
    display: flex;
`;

type position = 'up' | 'down' | 'left' | 'right';

interface IRotate extends HTMLAttributes<SVGElement> {
    from: position;
    to: position;
    playAnimation: boolean;
}

function translatePositionToDegrees(position: position): number {
    switch (position) {
        default:
        case 'down':
            return 0;
        case 'up':
            return 180;
        case 'left':
            return 90;
        case 'right':
            return 270;
    }
}

export default function Rotate({ from, to, playAnimation, ...restProps }: IRotate): JSX.Element {
    const { children } = restProps;
    const styles = useSpring({
        rotate: playAnimation ? translatePositionToDegrees(to) : translatePositionToDegrees(from)
    });

    return <AnimatedContainer style={styles}>{children}</AnimatedContainer>;
}
